import { render, staticRenderFns } from "./SavingError.vue?vue&type=template&id=0985822c&scoped=true&"
import script from "./SavingError.vue?vue&type=script&lang=js&"
export * from "./SavingError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0985822c",
  null
  
)

export default component.exports